import { useDispatch, useSelector } from "react-redux";

import { get_profile } from "../api";
import { set_profile_action, set_groups_action } from "../actions";
import { profileSelector } from "../selectors";

import useReduxSwr from "../../global/hooks/useReduxSwr";
import useWorkspaces from "./useWorkspaces";
import { useEffect } from "react";

interface WorkspacesType {
  activeWorkspace: {
    agreement: {
      promotion_code: string;
    };
    id: string;
    logo: string;
    name: string;
  };
  changeActiveWorkspace: (grpId: string) => void;
  list: {
    id: string;
    logo: string;
    name: string;
  }[];
  refetch: () => void;
  changeActiveWorkspaceIsLoading: boolean;
}

export default useProfile;

function useProfile() {
  let dispatch = useDispatch();
  let isLoggedIn = !!useSelector(profileSelector);
  let workspaces: WorkspacesType = useWorkspaces();
  let {
    data: profile,
    isValidating,
    error,
    revalidate,
  } = useReduxSwr({
    fetcher: () => Promise.all([get_profile(), workspaces.refetch()]),
    selector: profileSelector,
    onFinished: (data) => {
      let [profile, groups] = data;
      let defaultSelectedGroup = "personal";
      if (groups && groups.length > 0) {
        defaultSelectedGroup = groups[groups.length - 1].id;
      }
      dispatch(set_profile_action(profile));
      dispatch(set_groups_action(groups));
      if (!workspaces.activeWorkspace) {
        workspaces.changeActiveWorkspace(defaultSelectedGroup);
      }
    },

    // we shouldn't get profile when user hasn't logged in
    enabled: isLoggedIn,
  });
  useEffect(() => {
    if (isLoggedIn) {
      revalidate();
    }
  }, [isLoggedIn]);
  return {
    workspaces,
    data: profile,
    error: error,
    isValidating,
    revalidate,
  };
}
